module.exports = __webpack_public_path__ + "static/media/react.d5e08cd1.png";